import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeCaseStudyFields {
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  title: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
}

export type TypeCaseStudySkeleton = EntrySkeletonType<TypeCaseStudyFields, 'caseStudy'>
export type TypeCaseStudy<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeCaseStudySkeleton,
  Modifiers,
  Locales
>

export function isTypeCaseStudy<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeCaseStudy<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'caseStudy'
}

export type TypeCaseStudyWithoutLinkResolutionResponse = TypeCaseStudy<'WITHOUT_LINK_RESOLUTION'>
export type TypeCaseStudyWithoutUnresolvableLinksResponse = TypeCaseStudy<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeCaseStudyWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeCaseStudy<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeCaseStudyWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeCaseStudy<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeCaseStudyWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeCaseStudy<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
